export const NOTE_STATUS = [
  { label: 'Open', value: 'open' },
  { label: 'Deleted', value: 'deleted' },
];
